var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('h-f-fields',{attrs:{"input-type":"multi-select","multi-select":_vm.choices,"reduce":false},on:{"searchchange":_vm.searchChoices},model:{value:(_vm.selectedArray),callback:function ($$v) {_vm.selectedArray=$$v},expression:"selectedArray"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }